export default __webpack_public_path__ + "static/media/error.fa9b6146.svg";